var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup47(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#233155;stroke-width:2px;}.b{fill:#233155;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-54 -148)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(56 148)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 20,
    height: 24,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 1,
    y: 1,
    width: 18,
    height: 22,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4,
    height: 2,
    transform: "translate(54 165)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4,
    height: 2,
    transform: "translate(54 159)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4,
    height: 2,
    transform: "translate(54 153)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(63 154)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 3,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 3,
    cy: 3,
    r: 2
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-5989,5h-2a5.006,5.006,0,0,1,5-5,5,5,0,0,1,5,5l-2,0a2.98,2.98,0,0,0-.88-2.12A2.978,2.978,0,0,0-5986,2a3,3,0,0,0-3,3Z",
    transform: "translate(6052 161)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup47);
export default __webpack_public_path__ + "static/media/Group 47.496ecca1206ee2ec6516fbd602432ebb.svg";
export { ForwardRef as ReactComponent };